// Translation: Hub > Landing > Services (English)
export default Object.freeze({
	fallback: {
		title: 'Account information is not available right now'
	}
})
